import { render } from "./SosComponent.vue?vue&type=template&id=db3eea7e&scoped=true"
import script from "./SosComponent.vue?vue&type=script&lang=js"
export * from "./SosComponent.vue?vue&type=script&lang=js"

import "./SosComponent.vue?vue&type=style&index=0&id=db3eea7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3eea7e"]])

export default __exports__